import React, { useLayoutEffect, useState } from 'react';

/**
 * Splash screen using the official Connectify loading GIF. Holds for ~2 seconds,
 * then fades out. Once the fade completes the component unmounts so it never
 * blocks subsequent interactions.
 */
export const HomeSplash = ({ onDone }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useLayoutEffect(() => {
    // Lock page scroll BEFORE the browser paints so the scrollbar never flashes
    // beside the splash graphic (the home page underneath is tall/scrollable).
    // useLayoutEffect (not useEffect) runs before paint — no one-frame scrollbar.
    const el = document.documentElement;
    const body = document.body;
    const prevHtml = el.style.overflow;
    const prevBody = body.style.overflow;
    el.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    // 2s hold, then a 1s fade-out to reveal the home page underneath.
    const fadeTimer = setTimeout(() => setFadeOut(true), 2000);
    const doneTimer = setTimeout(() => onDone && onDone(), 3000); // 2s hold + 1s fade
    return () => {
      el.style.overflow = prevHtml;
      body.style.overflow = prevBody;
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black transition-opacity duration-[1000ms] ease-out ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
      data-testid="home-splash"
      aria-hidden="true"
    >
      <img
        src="/splash-loader.gif"
        alt=""
        className="w-[72rem] h-[72rem] max-w-[95vw] max-h-[95vw] sm:max-w-[95vh] sm:max-h-[95vh] object-contain select-none"
        draggable={false}
      />
    </div>
  );
};

export default HomeSplash;
